var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M17.3271 7.93615C17.9855 8.59451 17.9855 9.66192 17.3271 10.3203C16.6688 10.9786 15.6013 10.9786 14.943 10.3203C14.2846 9.66192 14.2846 8.59451 14.943 7.93615C15.6013 7.27779 16.6688 7.27779 17.3271 7.93615",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M11.8354 4.9268C12.8492 5.94054 12.8492 7.58413 11.8354 8.59787C10.8217 9.6116 9.17809 9.6116 8.16435 8.59787C7.15062 7.58414 7.15062 5.94055 8.16435 4.9268C9.17809 3.91307 10.8217 3.91307 11.8354 4.9268",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M5.05709 7.93615C5.71545 8.59451 5.71545 9.66192 5.05709 10.3203C4.39873 10.9786 3.33133 10.9786 2.67297 10.3203C2.01461 9.66192 2.01461 8.59451 2.67297 7.93615C3.33133 7.27779 4.39874 7.27779 5.05709 7.93615",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M19.1666 15.8331V14.9198C19.1666 13.7689 18.2341 12.8364 17.0833 12.8364H16.4158",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M0.833252 15.8331V14.9198C0.833252 13.7689 1.76575 12.8364 2.91659 12.8364H3.58409",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M14.449 15.8334V14.4992C14.449 12.8884 13.1431 11.5825 11.5323 11.5825H8.46647C6.85564 11.5825 5.5498 12.8884 5.5498 14.4992V15.8334",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.df028618cc88076cb67d87e043411f67.svg";
export { ForwardRef as ReactComponent };